/** Korte NL-definities (zelfde logica als Analytics glossary). */
export const DASHBOARD_METRIC_HINTS = {
  leadsTotal: 'Alle niet-gemergede leads in dit project (of alle projecten).',
  leadsNew30d: 'Leads met aanmaakdatum in de laatste 30 kalenderdagen — los van 7/30/90.',
  mailsSent: 'Som verzonden mail uit KPI-snapshots in de gekozen periode.',
  replyRate: 'Mail-replies gedeeld door verzonden mail in de periode.',
  bounceRate: 'Bounces gedeeld door verzonden mail. Waarschuwing boven 3%.',
  ga4Sessions: 'Som GA4-sessions uit dagelijkse integratie-snapshots.',
  gscClicks: 'Som Search Console-clicks uit snapshots (data ~3d vertraagd).',
} as const;
